import { define } from 'wicked-elements'

/**
 * Handles hiding/showing the page modules container
 * depending on if there are any visible modules or not.
 * This is necessary because there may be instances where
 * all page modules are used as sidebar modules. If so, 
 * the page modules container will only have hidden children,
 * on desktop. We hide the container as well to avoid gaps.
 */

define('[data-component~="page-modules"]', {
  init() {
    this.handleResize = this.handleResize.bind(this)
  },
  connected() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  disconnected() {
    window.removeEventListener('resize', this.handleResize)
  },
  handleResize() {
    if (this.hasNoVisibleChildren()) {
      this.element.classList.add('hidden')
    } else {
      this.element.classList.remove('hidden')
    }
  },
  hasNoVisibleChildren() {
    // Get all child elements of the given element
    var children = this.element.children;

    // Loop through each child element
    for(var i = 0; i < children.length; i++) {
      var child = children[i];

      // If the child's computed style is not 'none', return false
      if(window.getComputedStyle(child).display !== 'none') {
        return false;
      }
    }

    // If we've gotten through all child elements and none were visible, return true
    return true;
  }
})
